import { useGetReferenceEntityList } from "./useGetReferenceEntityList.js";
import { useCallback } from "react";
const useGetReferencedEntity = (opts) => {
  const getList = useGetReferenceEntityList(opts);
  return useCallback((path, id) => {
    const list = getList(path);
    return list.getChildEntityById(id);
  }, [getList]);
};
export {
  useGetReferencedEntity
};
//# sourceMappingURL=useGetReferencedEntity.js.map
